<template class="loginpage">
   <v-app>
      <div class="app flex-row align-items-center">
         <div class="container">

            <ddoWaiting :value="loading" color="primary" :message="$t('texts.loading')"/>

            <b-row class="justify-content-center">
               <div>
                  <img v-if="$config.values.brand=='ddo'"      src="/img/myddo-650x200-transparent.png" alt="My.DDO Logo" class="logo">
                  <img v-if="$config.values.brand=='smtp-pro'" src="/img/mysmtppro-650x200-transparent.png" alt="My.SMTP-PRO Logo" class="logo">
               </div>
            </b-row>

            <b-row class="justify-content-center">
               <v-chip
                  v-if="!$config.isProd"
                  class="ma-2"
                  color="primary"
               >
               {{ $t('titles._DEVELOPMENT') }}
               </v-chip>
            </b-row>

            <b-row class="justify-content-center">
               <button v-on:click="$i18n.locale='fr'"><country-flag country="fr" size='normal'/></button>
               <button v-on:click="$i18n.locale='en'"><country-flag country="gb" size='normal'/></button>
            </b-row>

            <b-row class="justify-content-center">
               <b-col md="9">
                  <b-card-group>
                     <b-card no-body class="text-white bg-primary">
                        <!--<b-card-body class="text-center">-->
                        <b-card-body>
                           <div>
                              <template>
                                 <h2 v-html="$t('texts.signup_new_website')+$config.values.upperbrand"></h2>
                                 <!--<h2>{{ $t('texts.signup_title') }}</h2>-->
                              </template>
                              <template v-if="$config.values.brand=='ddo'">
                                 <p v-html="$t('texts.signup_explanations_1_ddo')"></p>
                                 <br/><br/>
                                 <p v-html="$t('texts.signup_explanations_2_ddo')"></p>
                                 <b-button href="https://ddo.net/contact/" target="_blank">ddo.net</b-button>
                              </template>
                              <template v-if="$config.values.brand=='smtp-pro'">
                                 <p v-html="$t('texts.signup_explanations_1_smtppro')"></p>
                                 <br/><br/>
                                 <p v-html="$t('texts.signup_explanations_2_smtppro')"></p>
                                 <center>
                                    <div id="ddo_products_div" height="100px">
                                       <div v-for="product in products" :key="product.name" width="90%" height="50px">
                                          <v-card v-if="product.disabled==false" height="60px">
                                             <div v-if="product.link!=null">
                                                <center><a :href="compute_catalog_link(product.link)"><img :src="product.logo" width="150"/></a></center>
                                             </div>
                                             <div v-else>
                                                <center><img :src="product.logo" width="150"/></center>
                                             </div>
                                          </v-card>
                                          <br/>
                                       </div>
                                    </div>
                                 </center>
                              </template>
                           </div>
                        </b-card-body>
                     </b-card>
                     <b-card no-body class="p-4">
                        <b-card-body>

                           <ddoAlert :errors="errors"/>

                           <v-form v-if="isStatus=='login'" @submit.prevent="login()">
                              <h1>{{ $t('texts.signin_title') }}</h1>
                              <p class="text-muted">{{ $t('texts.signin_subtitle') }}</p>

                              <b-input-group class="mb-3">
                                 <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                                 <v-text-field v-model="username" maxlength="80" :label="$t('texts.signin_email')" required :hint="$t('hints.signin_email')"></v-text-field>
                              </b-input-group>
                              <b-input-group class="mb-4">
                                 <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                                 <v-text-field v-model="password" maxlength="40" :append-icon="show_pwd ? 'mdi-eye' : 'mdi-eye-off'" :type="show_pwd ? 'text' : 'password'" @click:append="show_pwd=!show_pwd" :label="$t('texts.signin_password')"  required :hint="$t('hints.signin_password')"></v-text-field>
                              </b-input-group>
                              <b-row>
                                 <b-col cols="6">
                                    <b-button type="submit" variant="primary" class="px-4">{{ $t('buttons.login') }}</b-button>
                                 </b-col>
                                 <b-col cols="6" class="text-right">
                                    <b-button variant="link" @click="isStatus='forgot'" class="px-0">{{ $t('texts.signin_forgot_password') }}</b-button>
                                 </b-col>
                              </b-row>
                           </v-form>

                           <v-form v-if="isStatus=='forgot'">
                              <h1>{{ $t('texts.forgotpassword_title') }}</h1>
                              <p class="text-muted">{{ $t('texts.forgotpassword_subtitle') }}</p>

                              <b-input-group class="mb-3">
                                 <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                                 <v-text-field v-model="username" maxlength="80" :label="$t('texts.signin_login')" required :hint="$t('hints.signin_login')"></v-text-field>
                              </b-input-group>
                              <b-row>
                                 <b-col cols="6">
                                    <b-button variant="primary" class="px-4" @click="forgot_password()" >{{ $t('buttons.send') }}</b-button>
                                 </b-col>
                                 <b-col cols="6" class="text-right">
                                    <b-button variant="link" @click="isStatus='login'" class="px-0">{{ $t('texts.forgotpassword_return') }}</b-button>
                                 </b-col>
                              </b-row>
                           </v-form>

                           <v-form v-if="isStatus=='reset'">
                              <h1>{{ $t('texts.resetpassword_title') }}</h1>
                              <p class="text-muted">{{ $t('texts.resetpassword_subtitle') }}</p>

                              <b-input-group class="mb-4">
                                 <v-text-field
                                    v-model="password1"
                                    maxlength="40"
                                    :append-icon="show_pwd1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show_pwd1 ? 'text' : 'password'"
                                    @click:append="show_pwd1=!show_pwd1"
                                    :label="$t('texts.change_password1')"
                                    required
                                    :hint="$t('hints.change_password1')"
                                    persistent-hint
                                    :rules="[passwordcomplexityRule(password1)]"
                                    autocomplete="new-password"
                                 >
                                    <template v-slot:message="{ message, key }">
                                       <span v-html="$t('hints.change_password1')"></span>
                                    </template>

                                 </v-text-field>

                                 <v-text-field
                                    v-model="password2"
                                    maxlength="40"
                                    :append-icon="show_pwd2 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show_pwd2 ? 'text' : 'password'"
                                    @click:append="show_pwd2=!show_pwd2"
                                    :label="$t('texts.change_password2')"
                                    required
                                    :hint="$t('hints.change_password2')"
                                    :rules="[passwordsmatchRule(),passwordcomplexityRule(password2)]"
                                 >
                                    <template v-slot:message="{ message, key }">
                                       <span v-html="$t('hints.change_password2')"></span>
                                    </template>
                                 </v-text-field>
                              </b-input-group>
                              <b-row>
                                 <b-col cols="6">
                                    <b-button variant="primary" class="px-4" @click="reset_password()" >{{ $t('buttons.resetpassword') }}</b-button>
                                 </b-col>
                                 <b-col cols="6" class="text-right">
                                    <b-button variant="link" @click="isStatus='login'" class="px-0">{{ $t('texts.forgotpassword_return') }}</b-button>
                                    <b-button variant="link" @click="isStatus='forgot'" class="px-0">{{ $t('texts.signin_forgot_password') }}</b-button>
                                 </b-col>
                              </b-row>
                           </v-form>

                        </b-card-body>

                     </b-card>

                  </b-card-group>
               </b-col>
            </b-row>
         </div>
      </div>
      <ddoCookies></ddoCookies>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import Vuetify from 'vuetify';
import refreshNav from '@/plugins/refresh_nav.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue';
import CountryFlag from 'vue-country-flag';
import ddoCookies from '@/components/ddoCookies.vue';

export default {
   name: 'Login',
   components: {
      ddoAlert,
      CountryFlag,
      ddoWaiting,
      ddoCookies,
   },

   data: () => {
      return {
         traces: '',
         location: '',
         loading: false,
         api_code: 'session',
         errors: [],
         username: null,
         password: null,
         logging: false,
         show_pwd: false,
         isStatus: 'login',
         isResetPassword: false,
         password1: null,
         password2: null,
         show_pwd1: false,
         show_pwd2: false,
         token: null,
         boolFormValid1: false,
         boolFormValid2: false,
         boolFormValid3: false,
         btnDisabled1: false,
         btnDisabled2: false,
         btnDisabled3: false,

         products: [
            {
               name: "SMTP-PRO",
               logo: "/img/products/smtppro/smtp-pro-2.png",
               text: "Bla bla",
               link: "/#/pages/checkout?pro_code=SMTP-PRO",
               disabled: false,
            },
            //{
            //   name: "SMS-PRO",
            //   logo: "/img/myddo-650x200.png",
            //   text: "Bla bla",
            //   link: "",
            //   disabled: false,
            //},
         ],
      }
   },

   created() {
   },

   mounted() {
      /*
       * If token is found in params, we are in 'reset-password'
       */
      if ( this.$route.params.token ) {
         this.token = this.$route.params.token;
         if (this.token!=null) {
            this.isStatus='reset';
         }
      }

      let errorinfos = sessionStorage.getItem('errorinfos');
      console.log('mounted(), errorinfos='+errorinfos);
      if ( errorinfos !== null && typeof errorinfos != "undefined" ) {
         errorinfos = JSON.parse(errorinfos);
         this.errors = [ errorinfos ];
      }
      sessionStorage.removeItem('session');
      sessionStorage.removeItem('errorinfos');
      //console.log('mounted(), remove session');
   },

   methods: {

      compute_catalog_link(product_link) {
         return window.location.origin+product_link;
      },

      async login() {
         this.logging = true;
         const { errorinfos, api_response } = await this.$api.login(this.$router,this.username,this.password, this.$i18n.locale);
         this.logging = false;
         console.log("errorinfos="+JSON.stringify(errorinfos))
         if ( api_response && api_response.error==0 && api_response.row.ses_sessionfields ) {
            refreshNav.methods.refreshNav(api_response.row.ses_sessionfields,api_response.row.platform_list);
            if ( api_response.row.ses_sessionid ) {
               sessionStorage.setItem('session',api_response.row.ses_sessionid);
               this.$router.push('/dashboard');
            }
         } else {
            this.errors = [ errorinfos ];
         }
         return false;
      },

      async forgot_password() {
         this.logging = true;
         var tkn_link = window.location.origin+'/#/pages/reset-password';
         var params = { tkn_marker: this.username, tkn_link: tkn_link };
         const { errorinfos, api_response } = await this.$api.createRow(this.$router,'token/forgot_password',params);
         this.logging = false;
         this.errors = [ errorinfos ];
      },

      async reset_password() {
         this.logging = true;
         var params = { usr_password: this.password1 };
         const { errorinfos, api_response } = await this.$api.deleteRow(this.$router,'token',this.token,params,'reset_password');
         this.logging = false;
         this.errors = [ errorinfos ];
         if ( api_response && api_response.error==0 ) {
            this.isStatus = 'login';
         }
      },

   },

   computed: {

      passwordcomplexityRule(password) {
         return v => this.$api._check_passwordcomplexity(v) || i18n.t('messages.password_not_complex');
      },

      passwordsmatchRule() {
         return v => this.password1==this.password2 || i18n.t('messages.passwords_not_equal');
      },

   }
}
</script>

<style scoped>
body {
   background-image: url(/img/datacenter-40.jpg);
   background-repeat: no-repeat;
   background-size: cover;
   background-color: transparent !important;
}
.theme--light.v-application {
   background-color: transparent !important;
}
</style>
